import ParticipantCamera from '../Slides/ParticipantCamera';

/**
 * Componente para o tile do moderador (quando presente)
 * @param {Object} props
 * @param {Object} props.participantMod - Participante moderador
 */
export const ModeratorTile = ({ participantMod }) => {
  if (!participantMod) return null;

  return (
    <div style={{ position: 'absolute', right: 32, bottom: 32, zIndex: 10 }}>
      <ParticipantCamera participant={participantMod} />
    </div>
  );
};
